import type { AxiosResponse } from 'axios';
import type { PaymentTimelineResponse } from 'types/entities/payment/gocardlessDirectdebitTimeline.type';

const getPaymentTimeline = (id: string): Promise<AxiosResponse<PaymentTimelineResponse>> =>
{
    return ApiClient.get<PaymentTimelineResponse>(`/gocardless/directdebit/${id}/timeline`);
};

export {
    getPaymentTimeline
};
